import { DomoscioAccess } from '@domoscio/domoscio-sdk-js'
import { getStorage } from '../../storage'
import * as Sentry from '@sentry/react'
import * as Errors from '../../components/Errors'
interface HttpCallBody {
  // eslint-disable-next-line camelcase
  access_token: string
  parameters: string
}

const storage = getStorage()
const access = storage.getItem('accesstoken')
const endpoint = process.env.REACT_APP_DOMOSCIO_ACCESS_URL
const env = process.env.REACT_APP_DOMOSCIO_ENV || 'dev'

const devMode = env === 'dev'

function reportingManager(error: any, body: HttpCallBody) {
  console.log(error)
  const message = error.errorMessage || error.message

  // report timeout errors
  const isTimeoutMessage = message?.includes('timed out')
  if (isTimeoutMessage) {
    Sentry.configureScope(scope => {
      scope.setTransactionName('Api Error')
      Sentry.captureException(new Error('Domoscio Access Error'), {
        extra: {
          user: body?.access_token || 'token not found',
          parameters: body?.parameters || 'parameters not found'
        }
      })
    })
    Errors.redirect('500')
  }
}

export const domoscioAccess = new DomoscioAccess(
  access,
  endpoint,
  reportingManager,
  devMode,
  'student'
)
